import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {BypassService} from "./bypass.service";
import {AuthGuardService} from "../../shared/services/auth-guard.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-bypass',
  templateUrl: './bypass.component.html',
  styleUrls: ['./bypass.component.css']
})
export class BypassComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private bypassService: BypassService,
    private authGuardService: AuthGuardService,
    private router: Router
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe(
      params => {
        this.bypassService.bypassWithSCPData(params).subscribe(data => {
          this.authGuardService.saveToken(data);
          this.bypassService.loadUserProfileInformation().subscribe(userProfile => {
            this.authGuardService.saveUserProfileInformation(JSON.stringify(userProfile));
            this.router.navigate(['request-list'])
          });
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// /app/src/app/modules/bypass/bypass.component.ts